import { render } from "./UsersIndex.vue?vue&type=template&id=0943c2fa"
import script from "./UsersIndex.vue?vue&type=script&lang=js"
export * from "./UsersIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__